<template lang="pug">
  v-dialog.box-popup-alert(v-model="openPopup" persistent width="363" height="441")
    v-card(style="border-radius: 5px;")
      v-card-text
        v-layout(align-center justify-center column fill-height)
          v-flex(v-if="buttonClose" style="height: 0.5em;")
            v-btn(style="position: absolute;top: 5px;right: 5px;height: 2em;width: 2em;" @click="closeAlertPopup(false)" color="#0855C4" fab  flat)
              v-icon(style="line-height: initial;") close
          v-flex(style="margin-top: 1.5em;height: 150px;")
            v-img
              img(:src="image" :style="styleImg")
          v-flex(style="margin:1em;text-align: center;")
            span.omnesMedium(style="font-size: 18px;color: #0855C4;") {{title}}
          v-flex.popup-message(style="text-align: center;width: 22em;")
            span(style="font-size: 16px;line-height: initial;color: #535D66;" v-html="message")
          v-flex.popup-buttons(style="margin-top: 2.5em;margin-bottom: 1em;")
            v-layout(v-if="secondButton" row justify-center)
              v-btn.popup-btn-primary(@click="closeAlertPopup(true)" style="background: #FFFFFF;border: 1px solid #EA0D90;border-radius: 4px;width: 165px;height: 55px;margin-right: 10px;")
                span.omnesSemibold(style="text-transform: initial;font-size: 18px;color: #EA0D90;") {{messageButton}}
              v-btn.popup-btn-secondary(@click="handleSecondButton" style="background: #EA0D90;border-radius: 4px;width: 165px;height: 55px")
                span.omnesSemibold(style="text-transform: initial;font-size: 18px;color: #FFFFFF;") {{secondButton}}
            v-btn.popup-btn-single(v-else @click="closeAlertPopup(true)" style="background: #EA0D90;border-radius: 4px;width: 145px;height: 55px")
              span.omnesSemibold(style="text-transform: initial;font-size: 18px;color: #FFFFFF;") {{messageButton}}
</template>

<script>
export default {
  props: [
    'openPopup',
    'image',
    'title',
    'message',
    'messageButton',
    'buttonClose',
    'imgHeight',
    'imgWidth',
    'secondButton'
  ],
  data () {
    return {
      styleImg: {
        height: (this.imgHeight || '150') + 'px',
        width: (this.imgWidth || '150') + 'px'
      }
    }
  },
  methods: {
    closeAlertPopup (item) {
      this.$emit('closeAlertPopup', item)
    },
    handleSecondButton () {
      this.$emit('secondButtonClick')
    }
  }
}
</script>

<style scoped>
/* Media queries para pantallas pequeñas */
@media only screen and (max-width: 425px) {
  .box-popup-alert >>> .v-dialog {
    max-width: 90% !important;
    width: 90% !important;
  }
  
  .popup-message {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 1em;
  }
  
  .popup-buttons {
    width: 100%;
    padding: 0 0.5em;
  }
  
  .popup-btn-primary,
  .popup-btn-secondary {
    width: 140px !important;
    height: 50px !important;
    margin-right: 8px !important;
  }
  
  .popup-btn-primary span,
  .popup-btn-secondary span {
    font-size: 15px !important;
  }
}

@media only screen and (max-width: 375px) {
  .box-popup-alert >>> .v-dialog {
    max-width: 95% !important;
    width: 95% !important;
  }
  
  .popup-message {
    padding: 0 0.5em;
  }
  
  .popup-message span {
    font-size: 14px !important;
  }
  
  .popup-buttons {
    margin-top: 1.5em !important;
    margin-bottom: 0.5em !important;
    padding: 0;
  }
  
  .popup-btn-primary,
  .popup-btn-secondary {
    width: 140px !important;
    height: 45px !important;
    margin-right: 6px !important;
  }
  
  .popup-btn-primary span,
  .popup-btn-secondary span {
    font-size: 15px !important;
  }
  
  .popup-btn-single {
    width: 140px !important;
    height: 45px !important;
  }
  
  .popup-btn-single span {
    font-size: 15px !important;
  }
}

@media only screen and (max-width: 325px) {
  .box-popup-alert >>> .v-dialog {
    max-width: 95% !important;
    width: 95% !important;
  }
  
  .popup-message {
    padding: 0 0.5em;
  }
  
  .popup-message span {
    font-size: 13px !important;
  }
  
  .popup-buttons {
    margin-top: 1.5em !important;
    margin-bottom: 0.5em !important;
    padding: 0;
  }
  
  .popup-btn-primary,
  .popup-btn-secondary {
    width: 120px !important;
    height: 36px !important;
    margin-right: 6px !important;
  }
  
  .popup-btn-primary span,
  .popup-btn-secondary span {
    font-size: 12px !important;
  }
  
  .popup-btn-single {
    width: 120px !important;
    height: 36px !important;
  }
  
  .popup-btn-single span {
    font-size: 12px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PopupAlertMessage.vue